jQuery(document).ready(function ($) {
    var $fancyboxgallery = $('[data-fancybox^="gallery-"]');

    if (!$fancyboxgallery.length) return

    Fancybox.defaults.infinite = 0;
    Fancybox.defaults.Hash = false;


    Fancybox.bind('[data-fancybox^="gallery-"]');
});

jQuery(document).ready(function ($) {
    var $fancyboxvideo = $('[data-fancybox-video]');

    if (!$fancyboxvideo.length) return

    Fancybox.bind('[data-fancybox-video]', {
        animated: false,
        showClass: false,
        hideClass: false,

        click: false,

        dragToClose: false,

        Image: {
            zoom: false,
        },

        Toolbar: {
            display: [
                {
                    id: "counter",
                    position: "center"
                },
                "close"
            ],
        },
    });
});